import { FC } from 'react';
import { observer } from 'mobx-react';
import { Card, Chip } from '@servicetitan/anvil2';
import { core } from '@servicetitan/anvil2/token';
import { TitleValue, TitleWithValueComponent } from './common/title-value';
import classNames from 'classnames';
import { NitrogenPressureTestResponseDto } from '../../models/nitrogen-pressure-test.response.dto';
import { NitrogenPressureTestRequestDto } from '../../models/calculator.dto';

export const NitrogenPressureTestAnswer: FC<{
    inputData: NitrogenPressureTestRequestDto['tool_input'];
    data: NitrogenPressureTestResponseDto;
    className?: string;
}> = observer(({ data, inputData, className }) => {
    const status = Number(data.test_pressure) > Number(inputData.final_pressure) ? 'red' : 'green';
    const chipColor =
        status === 'red' ? core.primitive.ColorRed100.value : core.primitive.ColorGreen100.value;

    const chipLabel = status === 'red' ? 'Leak Detected' : 'No Leak Detected';

    return (
        <Card className={classNames('w-100-i', className)}>
            <div
                style={{
                    flexGrow: '1',
                    display: 'grid',
                    gridTemplateColumns: '1fr 1fr',
                    rowGap: 12,
                }}
            >
                <TitleValue title="Actual Pressure" value={`${inputData.final_pressure} PSI`} />
                <TitleValue title="Target Pressure" value={`${data.test_pressure} PSI`} />
                <TitleValue title="Margin of Error" value={`${Number(data.error).toFixed(1)}%`} />
                <TitleWithValueComponent
                    title="Status"
                    value={<Chip size="small" color={chipColor} label={chipLabel} />}
                />
            </div>
        </Card>
    );
});
